import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from '../../apiClient';

export type K8SClusterStatus = {
  project_id: string;
  cluster_id: string;
  cluster_name: string;
  agent_version: string;
  last_heartbeat: string;
  init: boolean;
};

export type K8SClustersResponse = {
  clusters: K8SClusterStatus[];
  count: number;
};

export const k8sClustersQueries = {
  all: () => ['k8s-clusters'],
  byProject: (projectId: string) => [...k8sClustersQueries.all(), projectId],
  list: (projectId: string) =>
    queryOptions({
      queryKey: [...k8sClustersQueries.byProject(projectId), 'list'],
      queryFn: async () => {
        const clusters = await listK8SClusters(projectId);

        return clusters;
      },
    }),
} as const;

export const listK8SClusters = async (
  projectId: string,
): Promise<K8SClusterStatus[]> => {
  const getResponse = await fetchBackend(`/k8s/clusters/${projectId}`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  const data = (await getResponse.json()) as K8SClustersResponse;

  return data.clusters;
};

export const generateK8SToken = async (
  projectId: string,
  clusterName: string,
): Promise<string> => {
  const response = await fetchBackend('/k8s/clusters/generate/jwt', {
    method: 'POST',
    body: JSON.stringify({
      projectId,
      clusterName,
    }),
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  const data = (await response.json()) as { token: string };

  return data.token;
};
